import React, { FC, useEffect } from "react";
import { Box, BoxProps } from "theme-ui";
import "./lightbox.scss";

type LightboxType = BoxProps;

export const Lightbox: FC<LightboxType> = ({
  children,
  ...props
}: LightboxType) => {
  if (typeof document !== "undefined") {
    useEffect(() => {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      document?.addEventListener("DOMNodeInserted", handleBackdropChange);
    }, []);

    const handleBackdropChange = () => {
      const zilchBackdropClass = "zilch__lightbox-backdrop";
      const zilchCaptionClass = "zilch__lightbox-caption";

      const backdrop = document.querySelector(".w-lightbox-backdrop");
      const caption = document.querySelector(".w-lightbox-caption");

      const backdropAlreadyInDom = document.querySelector(
        `.${zilchBackdropClass}`
      );
      const captionAlreadyInDom = document.querySelector(
        `.${zilchCaptionClass}`
      );

      const container = document.querySelector(".lightbox-container");

      if (backdrop && !backdropAlreadyInDom) {
        backdrop.className += ` ${zilchBackdropClass}`;
        container?.appendChild(backdrop);
      } else if (caption && !captionAlreadyInDom) {
        caption.className += ` ${zilchCaptionClass}`;
      }
    };
  }
  return (
    <Box className="lightbox-container" variant="boxes.lightbox" {...props}>
      {children}
    </Box>
  );
};
